import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import OrderEditMainForm from 'components/OrderEditMainForm';
import AccordionController from 'components/AccordionController';
import General from 'components/OrderEditMainGeneral';
import Payments from 'components/OrderEditMainPayments';
import Passengers from 'components/OrderEditMainPassengers';
import Services from 'components/OrderEditMainServices';
import Accomodation from 'components/OrderEditMainAccomodation';
import Transport from 'components/OrderEditMainTransport';
import Contacts from 'components/OrderEditMainContacts';
import Documents from 'components/OrderEditMainDocuments';

import { OrderEditMain_order$key } from '__generated__/OrderEditMain_order.graphql';

type Props = {
  order: OrderEditMain_order$key;
};

const OrderEditMain: FC<Props> = props => {
  const order = useFragment(
    graphql`
      fragment OrderEditMain_order on Order {
        ...OrderEditMainForm_order
        ...OrderEditMainGeneral_order
        ...OrderEditMainPayments_order
        ...OrderEditMainPassengers_order
        ...OrderEditMainServices_order
        ...OrderEditMainAccomodation_order
        ...OrderEditMainTransport_order
        ...OrderEditMainContacts_order
        ...OrderEditMainDocuments_order
      }
    `,
    props.order
  );

  return (
    <OrderEditMainForm order={order}>
      <AccordionController id="order">
        <General order={order} />
        <Payments order={order} />
        <Passengers order={order} />
        <Services order={order} />
        <Accomodation order={order} />
        <Transport order={order} />
        <Contacts order={order} />
        <Documents order={order} />
      </AccordionController>
    </OrderEditMainForm>
  );
};

export default OrderEditMain;
